import axios from 'axios';
export class TranslationsService {
  private apiUrl: string;
  private translations!: any;

  constructor() {
    this.apiUrl = import.meta.env.VITE_APP_onBackstageAPI + 'translations/';
  }

  public async getAll(): Promise<any> {
    try {
      if (!this.translations) {
        const response = await axios.get(this.apiUrl);
        this.translations = response.data;
      }
      return this.translations;
    } catch (exception) {
      console.info('request failed to fetch translations ', exception);
      return {};
    }
  }

  public async getByLanguage(language: string): Promise<any> {
    try {
      const response = await axios.get(this.apiUrl + language);
      return response.data;
    } catch (exception) {
      console.info('request failed to fetch translations ', exception);
      return null;
    }
  }
}
